"use client";

import Link from "next/link";
import { useSelectedLayoutSegment } from "next/navigation";
import { useTranslations } from "next-intl";

export function DocsLink() {
  const href = process.env.NEXT_PUBLIC_DOC_URL || "https://doc.ai.soraliststudio.com";
  const t = useTranslations("header.nav");

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-foreground/60 transition-colors hover:text-foreground"
    >
      {t("docs")}
    </Link>
  );
}
